"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var H6 = _styledComponents["default"].h6.withConfig({
  displayName: "H6",
  componentId: "x88wye-0"
})(["font-size:18px;font-weight:600;line-height:22px;letter-spacing:-.1px;margin:0;"]);

var _default = H6;
exports["default"] = _default;